


























import Vue, { PropType } from "vue";
import VueClipboard from "vue-clipboard2";
import PortalDialog from "@bilibili/growup-portal-dialog";
import share2target from "@bilibili/share2target";
import { httpGet, httpPost } from "@bilibili/growup-utils/_esm5/http";
import { PAGE_URLS, shareChannels, shareConfig, picShareChannels, PicShareChannel } from "@/utils/config";
import { sharePrefix } from "@/utils/config";
import { SharePanelType, TaskStatus } from "../services/index";
import { parseParamToObj } from "@/utils/detect";
import { httpSafe } from "@/utils/filters";
import { store, mutations } from "../services/store";
import { drawCanvas, ImageObject } from "@/utils/poster/drawCanvasNew";
import { isAndroid, report, toast } from "@bilibili/growup-utils";
import { uploadImg } from "@bilibili/growup-utils/_esm5/img";
import { biliBridge, isSupport } from "@bilibili/js-bridge";
import { getCookie } from "@bilibili/growup-utils";
import styleV from "../sassVariables.js";
import { postGetWatchWord } from "@/views/Home/services";
import { logger, ActionType } from "@/utils/logger";
import { cutImage } from "@/utils/img";
Vue.use(VueClipboard);
Vue.use(PortalDialog, { blockMode: false }); // blockMode 属性参考 #弹窗冲突 段落
const search: any = parseParamToObj(location) || {};
const searchParams = {};
searchParams["picUrl"] = search["picUrl"] ? decodeURIComponent(search["picUrl"]) : "";
searchParams["awardName"] = search["awardName"] ? decodeURIComponent(search["awardName"]) : "";
searchParams["boxType"] = search["boxType"] ? decodeURIComponent(search["boxType"]) : "";
enum ShareStatus {
  Common,
  Pic
}
enum SharePicType {
  Exciting,
  NO_Task_Common,
  Has_Task
}
enum TitlePicType {
  Exciting_Hundred,
  Exciting_Fifty,
  Exciting_Others,
  Common_Task
}
enum BoxType {
  Reward = "reward_box",
  Task = "task_box",
  No_Win = "no_win",
  No_Chance = "no _chance"
}
import Bjax from "@bilibili/bjax";

const bjax = new Bjax();
export default Vue.extend({
  name: "sharePanel",
  data() {
    return {
      timer: null as any, // 画图计时器
      imageUrl: "", // 上传图片地址
      base64: "",
      picVisible: false,
      picRatio: 2,
      picArr: [
        {
          // 二维码
          x: "365",
          y: "745",
          width: "138",
          height: "138",
          radius: 0,
          borderX: "0",
          borderY: "0",
          borderColor: "rgba(255, 255, 255, 1)",
          borderLineWidth: "0",
          borderWidth: "0",
          borderHeight: "0",
          url: PAGE_URLS.INVITE,
          qrcodeChecked: true,
          src: ""
        },
        {
          x: "38",
          y: "37",
          width: "74",
          height: "74",
          borderX: "0",
          borderY: "0",
          radius: "37",
          borderLineWidth: "0",
          borderWidth: "0",
          borderHeight: "0",
          url: "http://i0.hdslb.com/bfs/face/member/noface.jpg",
          qrcodeChecked: false,
          src: "https://i0.hdslb.com/bfs/face/member/noface.jpg"
        },
        {
          // 奖品图
          x: "165",
          y: "165",
          width: "230",
          height: "230",
          borderX: "0",
          borderY: "0",
          borderLineWidth: "0",
          borderWidth: "0",
          borderHeight: "0",
          url: "//activity.hdslb.com/blackboard/static/20201112/28f8ecbd17f5bcc51d9fa3fd5bac7950/X5ZMPZOtc.png",
          src: "//activity.hdslb.com/blackboard/static/20201112/28f8ecbd17f5bcc51d9fa3fd5bac7950/X5ZMPZOtc.png"
        }
      ],
      shareStatus: ShareStatus.Common,
      sharePicType: SharePicType.Has_Task,
      picContainerScaleRatio: 1,
      enterInPicStatus: true
    };
  },
  props: {
    activityUid: {
      type: String,
      default: "pi",
      required: true
    },
    // 分享渠道信息列表
    channels: {
      type: Array as PropType<{ name: string; picture: string; share_channel: string; source: number }[]>,
      default() {
        return shareChannels;
      }
    },
    // 分享页面来源
    shareSource: {
      type: Number,
      default: 1
    },
    // 业务值
    bizId: {
      type: Number,
      default: 1
    },

    queryParams: {
      // 分享链接拓展参数
      type: Object,
      default() {
        return {};
      }
    },
    extra_data: {
      // 拓展参数
      type: String,
      default: ""
    },
    inviteUrl: {
      // 邀请页地址
      type: String,
      default: ""
    },
    shareType: {
      type: Number,
      // 默认是活动期间常驻在外的panel
      default: SharePanelType.Portal
    },
    taskStatus: {
      // 当前是否有任务
      type: Number,
      default: TaskStatus.NotHasTask
    },
    panelVisible: {
      type: Boolean,
      default: false
    },
    firstShowAward: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    panelVisible(val) {
      if (!val) {
        mutations.setLoading(false);
      }
      // 处理图片逻辑
      const index = this.channels.findIndex((item) => {
        return item.share_channel === "PIC";
      });
      if (index === -1) {
        return;
      }
      if (this.isResident) {
        return;
      }
      if (val) {
        this.enterInPicStatus = false;
        this.share({
          share_channel: "PIC"
        });
      } else {
        this.resetSharePicStatus();
      }
    },
    picVisible(val) {
      if (val) {
        this.getPicTransformScale();
      }
    }
  },

  created() {
    // 提前加载保存图片icon
    const saveImgIcon = new Image();
    saveImgIcon.src = picShareChannels[2].picture;
  },
  computed: {
    picContaninerStyle(): { transform: string } {
      return { transform: `scale(${this.picContainerScaleRatio})` };
    },
    isResident(): boolean {
      return this.shareType === SharePanelType.Resident;
    },
    isHasTask(): boolean {
      return this.taskStatus === TaskStatus.HasTask;
    },
    isNotHasTask(): boolean {
      return this.taskStatus === TaskStatus.NotHasTask;
    },
    posterData() {
      // 海报图base64
      return store.posterData;
    },
    usedChannels(): any {
      return this.inPicStatus ? picShareChannels : this.channels;
    },
    inPicStatus(): boolean {
      return this.shareStatus === ShareStatus.Pic;
    },
    awardType(): TitlePicType {
      // boxtype 区分任务宝箱与 高能宝箱
      if (searchParams["boxType"] === BoxType.Reward) {
        if (searchParams["awardName"] === "100元现金红包") {
          return TitlePicType.Exciting_Hundred;
        } else if (searchParams["awardName"] === "50元现金红包") {
          return TitlePicType.Exciting_Fifty;
        } else {
          return TitlePicType.Exciting_Others;
        }
      } else {
        return TitlePicType.Common_Task;
      }
    },
    titlePic(): string {
      if (this.awardType === TitlePicType.Exciting_Hundred) {
        return "//activity.hdslb.com/blackboard/static/0d82a81ec9aff95216c0273a83ab1ddb/MMJqhc6hnd.png";
      }
      if (this.awardType === TitlePicType.Exciting_Fifty) {
        return "//activity.hdslb.com/blackboard/static/0d82a81ec9aff95216c0273a83ab1ddb/3haL6AHqZR.png";
      }
      if (this.awardType === TitlePicType.Exciting_Others) {
        return "//activity.hdslb.com/blackboard/static/0d82a81ec9aff95216c0273a83ab1ddb/d9PwCglQq9.png";
      }
      return "//activity.hdslb.com/blackboard/static/0d82a81ec9aff95216c0273a83ab1ddb/QGoJYM7Spa.png";
    },
    titlePicInHundred(): boolean {
      return this.awardType === TitlePicType.Exciting_Hundred;
    },
    titlePicInFifty(): boolean {
      return this.awardType === TitlePicType.Exciting_Fifty;
    },
    titlePicInExcitingOthers(): boolean {
      return this.awardType === TitlePicType.Exciting_Others;
    },
    // 分享配置
    shareConfig() {
      let shareConfigHandled = shareConfig;

      if (this.taskStatus === TaskStatus.HasTask) {
        shareConfigHandled = {
          ...shareConfig,
          title: "我在B站开宝箱领福利!",
          text: "超多好礼就在B站弹幕宝箱。马上点击，你也能领福利!"
        };
      } else if (this.taskStatus === TaskStatus.NotHasTask && searchParams["boxType"] === BoxType.Reward) {
        shareConfigHandled = {
          ...shareConfig,
          title: "我发现宝藏啦!",
          text: `赢麻了! 我在B站看视频开出了${searchParams["awardName"]}! 你也来开宝箱吧!(๑•̀ㅂ•́)و✧`
        };
      } else {
        shareConfigHandled = {
          ...shareConfig,
          title: "恭喜你发现宝藏!",
          text: "上B站逛游戏区, 开弹幕宝箱! 戳我直达 >>"
        };
      }
      return shareConfigHandled;
    },
    userFace() {
      return store.userInfo["face"] || "https://i0.hdslb.com/bfs/face/member/noface.jpg";
    },
    backgroundImgURL(): string {
      if (this.sharePicType === SharePicType.NO_Task_Common) {
        return "//activity.hdslb.com/blackboard/static/0d82a81ec9aff95216c0273a83ab1ddb/ED7mWWQmLO.png";
      } else if (this.sharePicType === SharePicType.Exciting) {
        return "//activity.hdslb.com/blackboard/static/0d82a81ec9aff95216c0273a83ab1ddb/x5dD9erjhw.png";
      } else {
        return "//activity.hdslb.com/blackboard/static/0d82a81ec9aff95216c0273a83ab1ddb/K8ObSp0HLi.png";
      }
    }
  },
  methods: {
    resetSharePicStatus() {
      this.shareStatus = ShareStatus.Common;
      this.enterInPicStatus = true;
      this.picVisible = false;
      this.picContainerScaleRatio = 1;
    },
    changePicArr() {
      if (this.sharePicType === SharePicType.Exciting) {
        let picUrl = "";
        picUrl = searchParams["picUrl"];
        this.picArr = [
          {
            // 二维码
            x: `${125 * this.picRatio}`,
            y: `${335.5 * this.picRatio}`,
            width: `${64 * this.picRatio}`,
            height: `${64 * this.picRatio}`,
            radius: 0,
            borderX: "0",
            borderY: "0",
            borderColor: "rgba(255, 255, 255, 1)",
            borderLineWidth: "0",
            borderWidth: "0",
            borderHeight: "0",
            url: PAGE_URLS.INVITE,
            qrcodeChecked: true,
            src: ""
          },
          {
            x: `${139 * this.picRatio}`,
            y: `${88 * this.picRatio}`,
            width: `${37 * this.picRatio}`,
            height: `${37 * this.picRatio}`,
            borderX: "0",
            borderY: "0",
            radius: `${18.5 * this.picRatio}`,
            borderLineWidth: "0",
            borderWidth: "0",
            borderHeight: "0",
            url: cutImage(this.userFace, 100),
            qrcodeChecked: false,
            src: cutImage(this.userFace, 100)
          },
          {
            // 奖品图
            x: `${81 * this.picRatio}`,
            y: `${150 * this.picRatio}`,
            width: `${150 * this.picRatio}`,
            height: `${150 * this.picRatio}`,
            borderX: "0",
            borderY: "0",
            borderLineWidth: "0",
            borderWidth: "0",
            borderHeight: "0",
            url: picUrl,
            src: picUrl
          }
        ];
      } else if (this.sharePicType === SharePicType.NO_Task_Common) {
        this.picArr = [
          {
            // 二维码
            x: `${280.5 * this.picRatio}`,
            y: `${414 * this.picRatio}`,
            width: `${47.5 * this.picRatio}`,
            height: `${47.5 * this.picRatio}`,
            radius: 0,
            borderX: "0",
            borderY: "0",
            borderColor: "rgba(255, 255, 255, 1)",
            borderLineWidth: "0",
            borderWidth: "0",
            borderHeight: "0",
            url: PAGE_URLS.INVITE,
            qrcodeChecked: true,
            src: ""
          }
        ];
      } else if (this.sharePicType === SharePicType.Has_Task) {
        this.picArr = [
          {
            // 二维码
            x: `${106 * this.picRatio}`,
            y: `${210 * this.picRatio}`,
            width: `${100 * this.picRatio}`,
            height: `${100 * this.picRatio}`,
            radius: 0,
            borderX: "0",
            borderY: "0",
            borderColor: "rgba(255, 255, 255, 1)",
            borderLineWidth: "0",
            borderWidth: "0",
            borderHeight: "0",
            url: PAGE_URLS.INVITE,
            qrcodeChecked: true,
            src: ""
          },
          {
            x: `${139 * this.picRatio}`,
            y: `${88 * this.picRatio}`,
            width: `${37 * this.picRatio}`,
            height: `${37 * this.picRatio}`,
            borderX: "0",
            borderY: "0",
            radius: `${18.5 * this.picRatio}`,
            borderLineWidth: "0",
            borderWidth: "0",
            borderHeight: "0",
            url: cutImage(this.userFace, 100),
            qrcodeChecked: false,
            src: cutImage(this.userFace, 100)
          }
        ];
      }
    },
    getPicTransformScale() {
      this.$nextTick(() => {
        const picContainer = this.$refs.picContainer as HTMLElement;
        const sharePanel = this.$refs.sharePanel as HTMLElement;
        if (picContainer && sharePanel) {
          const picContainerBlock = picContainer.getBoundingClientRect();
          const sharePanelBlock = sharePanel.getBoundingClientRect();

          const share_panel_padding_top =
            Number.parseFloat(styleV.variablesSass.share_panel_padding_top) * 100 * window.dp;
          if (picContainerBlock.height + sharePanelBlock.height + share_panel_padding_top < window.innerHeight) {
            this.picContainerScaleRatio = 1;
          } else {
            this.picContainerScaleRatio =
              (window.innerHeight - sharePanelBlock.height - share_panel_padding_top) / picContainerBlock.height;
          }
        }
      });
    },
    getScrollableElement() {
      return this.$refs.shareListRef;
    },
    shareTarget(channel, config, cb) {
      // 自定义调用`share2Target`
      if (channel && config) {
        share2target(channel, config, (callback) => {
          if (cb) {
            cb(callback);
          }
        });
      }
    },
    savePic() {
      // 保存图片到系统相册。注意需要用户授权
      isSupport("ability.saveImageToPhotosAlbum").then((support) => {
        if (!support) {
          toast("当前版本过低，请更新至最新版本保存图片哦~");
        }
        biliBridge.callNative({
          method: "ability.saveImageToPhotosAlbum",
          data: {
            base64Data: this.base64
          },
          callback: (info) => {
            if (+info.code === 0) {
              toast("图片已保存，去分享给好友吧~");
            } else {
            }
          }
        });
      });
    },
    uploadImg(file) {
      const data = new FormData();
      data.append("file", this.b64toBlob(file.split("base64,")[1], "image/png"));
      data.append("bucket", "growup");
      return bjax.upload(`//api.bilibili.com/x/upload/web/image?csrf=${getCookie("bili_jct")}`, data, {
        headers: { "Content-Type": "multipart/form-data" }
      });
    },
    b64toBlob(b64Data, contentType = "", sliceSize = 512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [] as any;

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },

    // 点击分享渠道Emit对应事件
    share({ share_channel }) {
      // 如果当前处于分享图片阶段
      if (this.shareStatus === ShareStatus.Pic) {
        console.log("click");
        logger("activity.red-packet.active-page.share.click", ActionType.Click, {
          from_channel: search["from_channel"],
          box_type: searchParams["boxType"],
          is_task: this.taskStatus === TaskStatus.HasTask ? 1 : 0,
          popup: "click",
          picChannel: share_channel,
          share_type: "picture"
        });
        const base = {
          type: "image" as any,
          title: "弹幕宝箱",
          text: "弹幕宝箱",
          imageUrl: "",
          url: location.href
        };

        if (share_channel === PicShareChannel.WEIXIN_PIC || share_channel === PicShareChannel.QQ_PIC) {
          this.uploadImg(this.posterData)
            .then((res) => {
              const { code, data: d } = res as any;
              if (+code === 0) {
                const { location } = d;
                base.imageUrl = location.replace(/^https?:/, "https:");
                share2target(share_channel === PicShareChannel.WEIXIN_PIC ? "weixin" : "qq", base, (data) => {
                  this.handleShareError(data);
                });
              } else {
                toast("网络不佳,请重试~");
              }
            })
            .catch(() => {
              toast("网络不佳,请重试~");
            });
        }

        if (share_channel === PicShareChannel.SAVE_PIC) {
          this.savePic();
        }
        this.resetSharePicStatus();
        this.$emit("close");
        return;
      }

      const c = share_channel.toLocaleLowerCase();

      report("share", { share_channel });
      if (this.picVisible && c === "pic") {
        console.log("click");
        logger("activity.red-packet.active-page.share.click", ActionType.Click, {
          from_channel: search["from_channel"],
          box_type: searchParams["boxType"],
          is_task: this.taskStatus === TaskStatus.HasTask ? 1 : 0,
          popup: "click",
          share_type: "picture"
        });
        this.shareStatus = ShareStatus.Pic;
        return;
      }
      httpPost(`${sharePrefix}/user/token`, {
        data: {
          tp: 0,
          activity_uid: this.activityUid,
          source: this.shareSource || c || 1,
          from: search["from"]
        }
      })
        .then((res) => {
          const { code, data } = res;

          if (code === 0 && data.token) {
            const token = data.token;
            if (c === "command") {
              postGetWatchWord(token, this.activityUid)
                .then(({ watchword }) => {
                  logger("activity.red-packet.active-page.share.click", ActionType.Click, {
                    from_channel: search["from_channel"],
                    box_type: searchParams["boxType"],
                    is_task: this.taskStatus === TaskStatus.HasTask ? 1 : 0,
                    share_type: "code"
                  });
                  this.copyByJsBridge(watchword);
                  toast("活动口令已复制，快去分享给你的好友吧～");
                })
                .catch(() => {});
              return;
            }
            // url
            httpGet(`${sharePrefix}/share/url?activity_uid=${this.activityUid}&share_channel=${share_channel}`)
              .then((res) => {
                const { code, data } = res;
                if (code === 0 && data.url) {
                  return data.url;
                }
              })
              .then((baseUrl) => {
                const b = baseUrl || this.inviteUrl;
                let link = "";
                try {
                  link = this.makeSharePageUrl(b, token, c);
                } catch (error) {
                  console.error(error);
                }

                if (c === "copy") {
                  logger("activity.red-packet.active-page.share.click", ActionType.Click, {
                    from_channel: search["from_channel"],
                    box_type: searchParams["boxType"],
                    is_task: this.taskStatus === TaskStatus.HasTask ? 1 : 0,
                    share_type: "link"
                  });
                  this.copyByJsBridge(link);
                  toast("活动链接已复制，快去分享给你的好友吧～");
                  return;
                }

                this._makeShare(c, link);
              });
          } else {
            report("share_failed_code", { code });
            return Promise.reject(res);
          }
        })
        .catch((error) => {
          report("share_failed", { error });
          toast(error ? error.message : "分享失败，请稍后再试");
        });
    },
    copyByJsBridge(text: string) {
      /**
       * 复制到粘贴板
       */
      biliBridge.callNative({
        method: "ability.copyToClipboard",
        data: {
          content: text
        },
        callback() {}
      });
    },
    _makeShare(c, link) {
      const s = { ...this.shareConfig };
      const base = {
        type: "web",
        url: link,
        ...s
      } as {
        title: string;
        text: string;
        type: string;
        url: string;
      };
      let callbackResult;
      if (["weixin", "qq", "sina", "bili"].indexOf(c) > -1) {
        if (c === "sina") {
          base.title += "，" + base.text;
          base.text = "";
        }
        logger("activity.red-packet.active-page.share.click", ActionType.Click, {
          from_channel: search["from_channel"],
          box_type: searchParams["boxType"],
          is_task: this.taskStatus === TaskStatus.HasTask ? 1 : 0,
          share_type: c === "weixin" ? "wechat" : c
        });
        share2target(c, base, (cb) => {
          this.handleShareError(cb);
          callbackResult = cb;
        });
      } else if (["weixin_monment", "q_zone"].indexOf(c) > -1) {
        base.type = "image";
        // 安卓QQ空间分享走卡片
        if (c === "q_zone" && isAndroid) {
          base.type = "web";
          share2target(c, base, (cb) => {
            this.handleShareError(cb);
            callbackResult = cb;
          });
        }
      } else if (c === "pic") {
        this.decideSharePicType();
        this.changePicArr();
        this.makePicShare(c, callbackResult, base);
      }
    },
    decideSharePicType() {
      if (this.firstShowAward) {
        if (searchParams["boxType"] === BoxType.Reward) {
          this.sharePicType = SharePicType.Exciting;
        } else {
          this.sharePicType = SharePicType.Has_Task;
        }
      } else {
        if (this.taskStatus === TaskStatus.HasTask) {
          this.sharePicType = SharePicType.Has_Task;
        } else if (this.taskStatus === TaskStatus.NotHasTask && searchParams["boxType"] === BoxType.Reward) {
          this.sharePicType = SharePicType.Exciting;
        } else {
          this.sharePicType = SharePicType.NO_Task_Common;
        }
      }
    },
    makeSharePageUrl(baseUrl, token, channel) {
      const queryArr = Object.keys(this.queryParams);
      const hasTask = this.taskStatus === TaskStatus.HasTask ? "1" : "";

      if (queryArr.length > 0) {
        let str = "";
        for (const i of queryArr) {
          if (this.queryParams.hasOwnProperty(i)) {
            str = str + `&${i}=${this.queryParams[i]}`;
          }
        }

        return `${baseUrl}?token=${token}&channel=${channel}&${str}&hasTask=${hasTask}`;
      } else {
        return `${baseUrl}?token=${token}&channel=${channel}&hasTask=${hasTask}`;
      }
    },
    handleShareError(cb) {
      const { errCode, errMsg } = cb || {};
      if (errCode === -1) {
        toast(errMsg || "不支持该渠道");
      }
      this.$emit("shareError", cb);
    },
    close() {
      if (this.shareType === SharePanelType.Resident) {
        this.resetSharePicStatus();
      } else {
        this.$emit("close");
      }
    },
    makePicShare(
      channel: string,
      _: any,
      shareConfig: {
        imageUrl?: string;
        text: string;
        title: string;
        type: string;
        url: string;
      }
    ) {
      let url = "";

      // 如果动态地址为空，那这里只取query部分(包含token、channel 等)
      if (shareConfig.url.indexOf("undefined") > -1) {
        url = `${PAGE_URLS.INVITE}${shareConfig.url.replace("undefined", "")}`;
      } else {
        url = shareConfig.url;
      }
      // 更新二维码字符串
      this.picArr[0].src = this.picArr[0].url = url;
      // 分享渠道点击事件，这里只处理`pic`海报分享情况
      if (channel === "pic") {
        // 画海报图
        this.draw(channel, shareConfig);
      }
    },
    renderCanvas(arr, channel, shareConfig) {
      const pAll: any[] = [];
      for (const i of arr) {
        // eslint-disable-next-line babel/new-cap
        const p = new window.QRCode.toDataURL(this.picArr[i].url, {
          errorCorrectionLevel: "L",
          margin: 1,
          scale: 7,
          color: {
            dark: "#0a0647",
            light: "#ffffff"
          }
        }).then((text) => {
          this.picArr[i].src = text;
          // this.renderImage();
        });
        pAll.push(p);
      }
      Promise.all(pAll).then(() => {
        this.renderImage(channel, shareConfig);
      });
    },
    renderImage(channel, shareConfig) {
      const imgObjs: ImageObject[] = this.picArr.map((i) => {
        i.radius = i.radius || 0;
        return {
          src: httpSafe(i.src),
          args: [+i.x, +i.y, +i.width, +i.height],
          radius: +i.radius,
          border: {
            borderLineWidth: +i.borderLineWidth,
            borderColor: i.borderColor,
            borderargs: [+i.borderX, +i.borderY, +i.borderWidth, +i.borderHeight]
          }
        };
      });

      mutations.setLoading(true);
      // 5秒未生成关闭
      this.timer = setTimeout(() => {
        report("draw_failed");
        window.__Fission.custom({
          msg: {
            custom_key: "draw_failed",
            custom_value: JSON.stringify(this.picArr)
          }
        });
        mutations.setLoading(false);
        if (!this.picVisible) {
          toast("图片生成失败~");
        }
      }, 5000);

      drawCanvas(
        this.backgroundImgURL,
        imgObjs,
        [],
        () => {},
        (base64) => {
          mutations.setPosterData(base64);
          this.base64 = base64;
          mutations.setLoading(false);
          clearTimeout(this.timer);
          if (channel === "q_zone" && !isAndroid) {
            uploadImg(base64).then((res) => {
              const { data } = res;
              const { code, data: d } = data as any;
              if (+code === 0) {
                shareConfig.imageUrl = d.location.replace(/^http:/, "https:");
                // @ts-ignore
                this.$refs.shareRef.shareTarget(channel, shareConfig);
              }
            });
          } else {
            const popup = this.enterInPicStatus ? "click" : "auto";
            console.log(popup);
            logger("activity.red-packet.active-page.share.click", ActionType.Click, {
              from_channel: search["from_channel"],
              box_type: searchParams["boxType"],
              is_task: this.taskStatus === TaskStatus.HasTask ? 1 : 0,
              popup,
              share_type: "picture"
            });
            this.picVisible = true;
            mutations.setLoading(false);
            if (this.enterInPicStatus) {
              this.shareStatus = ShareStatus.Pic;
            }
            // this.$dialog.show("picDialog");
          }
        }
      );
    },
    draw(channel, shareConfig) {
      const qrindexArr: number[] = [];
      for (let i = 0; i < this.picArr.length; i++) {
        if (this.picArr[i].qrcodeChecked) {
          qrindexArr.push(i);
        } else if (this.picArr[i].url) {
          this.picArr[i].src = this.picArr[i].url.replace(/http:\/\//, "https://");
        }
      }

      if (qrindexArr.length !== 0) {
        this.renderCanvas(qrindexArr, channel, shareConfig);
      } else {
        this.renderImage(channel, shareConfig);
      }
    }
  }
});
